module.exports = __webpack_public_path__ + "static/media/icon-warning.cd466b53.svg";